<pbc-filter [config]="GutachtenStatiFilterConfig" [filter]="gutachtenStati.filter$ | async" (filterChange)="gutachtenStati.filter$.next($event)"></pbc-filter>
